import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ContentEnum, GridCell, RowCell } from '../../models/sections-model';


@Component({
  selector: 'kw-content-layer-renderer',
  templateUrl: './content-layer-renderer.component.html',
  styleUrls: ['./content-layer-renderer.component.scss']
})
export class ContentLayerRendererComponent implements OnInit, OnChanges {
  @Input() cell:GridCell | RowCell;
  contentEnum:ContentEnum;
  contentEnumVal:string; //Feature,Product Cell

  hasProductId = false;
  constructor() { }
  

  ngOnInit(): void {
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if(changes["cell"]){
      this.contentEnum = this.cell.contentEnum;
      this.contentEnumVal = this.getEnumValue(this.cell);
      //console.log(this.cell.contentEnum)
      if(this.cell.contentEnum == ContentEnum.PRODUCT_CELL){
        this.cell.contentElements.forEach(el => {
          if(el.containerPadding == undefined){
            el.containerPadding = "4px";
          }
        })
      }
      const productIdCnt = this.cell.contentElements.find(cnt => cnt.name === "Product Id");
      if(productIdCnt != undefined){
        this.hasProductId = true;
      }
      //console.log(this.cell.contentElements);
    }
  }

  getEnumValue(cell:RowCell|GridCell){
    let enumValue:string;
    let cntEnum = cell.contentEnum;
    if(cntEnum != undefined){
      if((cntEnum).includes(".")){
        let enumKey = cntEnum.split('.')[1] as keyof typeof ContentEnum;
        enumValue = ContentEnum[enumKey];
      }else if(ContentEnum[cntEnum] != undefined){
        enumValue = ContentEnum[cntEnum]
      }else{
        enumValue = cntEnum;
      }
    }
    return enumValue;
  }


}
